import React,{useEffect}  from 'react';
import EmptyDashboard from '../../pages/dashboard/EmptyDashboard';
import { DataStorage } from '../../utils/DataStorage';



export const LoaderInfo = (props:any) => {
   useEffect(() => {
    if(DataStorage.getDeepLink() == null){
      DataStorage.setDeepLink(window.location.toString());
    } 
  }, []);
  
  return (<EmptyDashboard />);
};
